import { getConfig as getSharedConfig } from '@newfront-insurance/shared-public-config';

export function getConfig() {
  return getSharedConfig({
    customConfigs: {
      production: { NOVA_ADDINS: { CLIENT_ID: 'ec936df8-0fcc-4571-ae53-e3cff47a08c0' } },
      staging: { NOVA_ADDINS: { CLIENT_ID: '70c292ba-9bbd-4fc8-a6bb-2d99060eb06c' } },
      localhost: { NOVA_ADDINS: { CLIENT_ID: '5b95077e-6304-46bc-a7e7-e5d3088b80a5' } },
      development: { NOVA_ADDINS: { CLIENT_ID: '5b95077e-6304-46bc-a7e7-e5d3088b80a5' } },
    },
  });
}
